export const PREFIX = 'app/user-preferences' as const;

export const CHANGE_PASSWORD_SUCCESS = `${PREFIX}/CHANGE_PASSWORD_SUCCESS` as const;
export const CHANGE_PASSWORD_ERROR = `${PREFIX}/CHANGE_PASSWORD_ERROR` as const;
export const CHANGE_USER_SETTINGS_SUCCESS = `${PREFIX}/CHANGE_USER_SETTINGS_SUCCESS` as const;
export const CHANGE_USER_SETTINGS_ERROR = `${PREFIX}/CHANGE_USER_SETTINGS_ERROR` as const;

export const USER_SETTINGS_FORM = 'user-settings-form';
